module.exports = __webpack_public_path__ + "img/pool-composer.ad38e95f.svg";